import { render, staticRenderFns } from "./event-label.vue?vue&type=template&id=cdcdb7a2"
import script from "./event-label.vue?vue&type=script&lang=js"
export * from "./event-label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports